export default __webpack_public_path__ + "assets/images/zoom-icon-781b5970.svg";